import { useQuery } from "../misc/useQuery";
import { usePackageWithId } from "../admin/packages/usePackageWithId";
import { useOrderWithId } from "../orders/useOrderWithId";
import type { SavedOrder } from "../orders/orderTypes";
import type { PackageResponse } from "../admin/packages/packagesApi";

export type Response =
  | { type: "FROM_ORDER"; data: SavedOrder | null | undefined; isLoading: boolean }
  | {
      type: "FROM_PACKAGE";
      data: PackageResponse | null | undefined;
      isLoading: boolean;
    }
  | { type: null; isLoading: boolean; data: null };

export const useCalculationFromQuery: () => Response = () => {
  const query = useQuery();
  const fromPackage = query.get("fromPackage");
  const fromOrder = query.get("fromOrder");
  const { data: selectedPackage, isLoading: isPackageLoading } = usePackageWithId(fromPackage ?? undefined);
  const { order, isLoading: isOrderLoading } = useOrderWithId(fromOrder ?? "");
  if (fromOrder) {
    return { type: "FROM_ORDER", data: order, isLoading: isOrderLoading };
  }
  if (fromPackage) {
    return { type: "FROM_PACKAGE", data: selectedPackage, isLoading: isPackageLoading };
  }
  return { type: null, isLoading: false, data: null };
};
